module.exports = __webpack_public_path__ + "static/media/16b-01-HOME_SG-2016-125x95cm-oleo-sobre-papel.0d296667.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/16b/16b-01-HOME_SG-2016-125x95cm-oleo-sobre-papel.jpg
// module id = 188
// module chunks = 0